import type { FC } from '../../lib/teact/teact';
import React, { useCallback } from '../../lib/teact/teact';

import useHistoryBack from '../../hooks/useHistoryBack';
import useLang from '../../hooks/useLang';

import Button from '../ui/Button';

import './AppInactive.scss';

import appInactivePath from '../../assets/app-inactive.png';

const AppInactive: FC = () => {
  const lang = useLang();

  const handleReload = useCallback(() => {
    window.location.reload();
  }, []);

  useHistoryBack({
    isActive: true,
    onBack: handleReload,
    shouldResetUrlHash: true,
  });

  return (
    <div id="AppInactive">
      <div className="content">
        <img src={appInactivePath} alt="" />
        <h3 className="title">{lang('AppInactiveTitle')}</h3>
        <div className="description">
          {lang('AppInactiveDescription', process.env.PROJECT_NAME!)}
          <br />
          {lang('AppInactiveReloadHint')}
        </div>
        <div className="actions">
          <Button isText ripple onClick={handleReload}>
            {lang('AppInactiveReload')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default AppInactive;
